export default __webpack_public_path__ + "static/Rlogo-15e6dc185999de8f8b7a0c71df474b0b.svg";